/**
 * Formats a given number of minutes into hours.
 *
 * @param value Minutes to format
 * @param precision Precision to format to
 */
export function minutesToHours(value, precision = 1) {
    return (value / 60).toFixed(precision);
}
